// extracted by mini-css-extract-plugin
export default {"duoToneIcons":"SiteCard_duoToneIcons__lh4NR","cardSite":"SiteCard_cardSite__XQGCO","rightCardBody":"SiteCard_rightCardBody__qs+LC"};